<template>
  <el-dialog
    id="get-activation-code-dialog"
    :visible.sync="visible"
    width="50vw"
    center
    :title="$t('Household.Household', {tabletNote: tabletNote})"
    @closed="onClosed"
  >
    <div class="content">
      <div class="code-row">
        <div class="title">
          {{ $t('GetActivationCode.Title') }}
        </div>
        <div class="code">
          {{ code }}
        </div>
        <div class="button">
          <el-button
            type="primary"
            :disabled="isGettingCode"
            @click="btnGetCode"
          >
            {{ $t('GetActivationCode.GenerateCodeButton') }}
          </el-button>
        </div>
      </div>
      <div class="info">
        <p>{{ $t('GetActivationCode.InfoText1') }}<span class="highlight">{{ $t('GetActivationCode.InfoHighlight1') }}</span>{{ $t('GetActivationCode.InfoText2') }}<span class="highlight">{{ $t('GetActivationCode.InfoHighlight2') }}</span></p>
        <p>{{ $t('GetActivationCode.InfoText3') }}</p>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { housekeeperAPI } from '@/api/HousekeeperAPI.js'

export default {
  name: 'GetActivationCode',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      visible: false,
      code: '',
      isGettingCode: false,
      tabletId: '',
      tabletNote: ''
    }
  },
  methods: {
    /**
     * 對話框開啟
     */
    open (tabletId, tabletNote) {
      this.visible = true
      this.tabletId = tabletId
      this.tabletNote = tabletNote
    },
    /**
     * 對話框關閉時的回調函數
     */
    onClosed () {
      this.code = ''
    },

    /**
     * 產生序號按鈕點擊事件
     */
    async btnGetCode () {
      this.isGettingCode = true
      try {
        const { data } = await housekeeperAPI.activateCommunityTabletDeviceSerial(this.tabletId)
        this.code = data.Data.SerialNumber
      } catch (error) {
        console.log(error)
      } finally {
        this.isGettingCode = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#get-activation-code-dialog {
  ::v-deep .el-dialog {
    @include basicDialog();
    .el-dialog__body {
      padding: 0;
      overflow-y: hidden;
    }
  }
  .code-row {
    display: flex;
    > div {
      height: 120px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: solid 1px $borderDark1;
    }
    .title {
      width: 27.5%;
      border-right: solid 1px $borderDark1;
      background-color: $whiteHover;
      color: $mainFontColor;
      font-size: 17px;
      font-weight: bold;
    }
    .code {
      width: 45%;
      font-size: 38px;
      color: $mainFontColor;
      font-weight: bold;
      border-right: solid 1px $borderDark1;
    }
    .button {
      width: 27.5%;
    }
  }
  .info {
    color: $mainFontColor;
    font-size: 17px;
    line-height: 1.9;
    padding: 30px 35px 26px;
    .highlight {
      color: $dangerColor;
      background-color: $lightYellowColor;
      font-weight: bold;
      padding: 8px 5px 1px;
      line-height: initial;
    }
  }
}
</style>
